import {
    AfterViewInit, ChangeDetectorRef, Directive, Input,
    OnDestroy, Optional, SkipSelf,
} from "@angular/core";
import { Subscription } from "rxjs";
import { ImmutableRedux } from "../../redux/immutable-redux.service";
import { RowSelectionManagerDirective } from "./manager.directive";

@Directive({
    selector: "[row-selection-select-all]",
})
export class SelectAllDirective implements AfterViewInit, OnDestroy {
    @Input("bulkSelectManager") public managerPropRef: RowSelectionManagerDirective;
    public selectedIds;
    public state$: Subscription;

    constructor(
        @SkipSelf() @Optional() public parentManager: RowSelectionManagerDirective,
        public ngRedux: ImmutableRedux<any>,
        public changeDetectorRef: ChangeDetectorRef,
    ) { }

    public ngAfterViewInit() {
        this.state$ = this.ngRedux.select(this.manager.rootProp, this.manager.stateProp).subscribe((state) => {
            this.selectedIds = state.ids;
            this.changeDetectorRef.markForCheck();
        });
    }

    public ngOnDestroy() {
        this.state$.unsubscribe();
    }

    public get toggleState() {
        const selectedIds = this.manager.selectedIds || {};
        const allIds = this.manager.allDetailIds || [];
        return !!(allIds.length && allIds.every((possibleId) => selectedIds[possibleId]));
    }

    public toggle() {
        this.manager.dispatchToggleAll();
    }

    public get manager() {
        return this.parentManager || this.managerPropRef;
    }
}
